import { useTheme } from 'context/ThemeContext'
import { Layer, Source, useMap } from 'react-map-gl'
import { useSelector } from 'react-redux'
import { RootState } from 'utils/interfaces'

const LidarMapLayer = ({ show, beforeId }: { show: boolean; beforeId?: string }) => {
  const { theme } = useTheme()
  const { current: map } = useMap()
  const lidarMapLayer = useSelector((state: RootState) => state.robot.lidarMapLayer)
  const currentLidarMap = useSelector((state: RootState) => state.robot.telemetry?.localization_info?.current_lidar_map)

  if (!show || !currentLidarMap || !lidarMapLayer.layer || !lidarMapLayer.layer.urlTiles) return null
  if (lidarMapLayer.layer.name !== currentLidarMap) return null

  // Dynamically verify that the layer beforeId actually exists on the map to prevent Mapbox fatal crashes
  const safeBeforeId = beforeId && map && map.getLayer(beforeId) ? beforeId : undefined

  let tilesBaseUrl = lidarMapLayer.layer.urlTiles.replace('https://nginx', '')
  let searchParams = ''
  try {
    const urlObj = new URL(tilesBaseUrl, window.location.origin)
    searchParams = urlObj.search
    urlObj.search = ''
    tilesBaseUrl = urlObj.toString().replace(window.location.origin, '')
  } catch (e) {
    const queryIndex = tilesBaseUrl.indexOf('?')
    if (queryIndex !== -1) {
      searchParams = tilesBaseUrl.slice(queryIndex)
      tilesBaseUrl = tilesBaseUrl.slice(0, queryIndex)
    }
  }

  if (!tilesBaseUrl.endsWith('/')) {
    tilesBaseUrl += '/'
  }

  const tilesUrl = `${tilesBaseUrl}{z}/{x}/{y}.png${searchParams}`

  return (
    <Source key={tilesUrl} id="lidar-map" type="raster" scheme="tms" tiles={[tilesUrl]}>
      <Layer
        id="lidar-map-layer"
        source="lidar-map"
        type="raster"
        beforeId={safeBeforeId}
        layout={{ visibility: show ? 'visible' : 'none' }}
        paint={
          {
            'raster-opacity': 1.0,
            'raster-fade-duration': 0,
            'raster-color': [
              'interpolate',
              ['linear'],
              ['raster-value'],
              0,
              theme === 'dark' ? '#00ff00' : '#ff00c8',
              255,
              'rgba(255, 255, 255, 0)',
            ],
            'raster-color-range': [0, 255],
          } as any
        }
        minzoom={14}
        maxzoom={24}
      />
    </Source>
  )
}

export default LidarMapLayer
